import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import {
  getError,
  getToastMessage,
  setError,
  setToast
} from "../../../../controller/reducer/ui";

const notify = (message) => toast.dark(message, { autoClose: 2500 });

const ToastDisplay = () => {
  const dispatch = useDispatch();
  const err = useSelector(getError);
  const msg = useSelector(getToastMessage);

  useEffect(() => {
    if (err) {
      notify(err);
      dispatch(setError(""));
    }
  }, [err, dispatch]);

  useEffect(() => {
    if (msg) {
      notify(msg);
      dispatch(setToast(""));
    }
  }, [msg, dispatch]);
  return <ToastContainer position="top-right" autoClose={3000} />;
};

export default ToastDisplay;
